<template>
  <component v-if="rolActual && user.rol" :is="rolActual" />
</template>

<script>
import { mapState } from 'vuex'
import DashboardAdmin from './DashboardAdmin'
import DashboardInspirador from './DashboardInspirador'
import DashboardMerani from './DashboardMerani'

export default {
  components: {
    DashboardAdmin,
    DashboardMerani,
    DashboardInspirador
  },
  data () {
    return {
      rolActual: ''
    }
  },
  computed: {
    ...mapState('user', [
      'user'
    ])
  },
  watch: {
    user () {
      this.loadDashboard()
    }
  },
  mounted () {
    this.loadDashboard()
  },
  methods: {
    loadDashboard () {
      switch (String(this.user.rol).toLowerCase()) {
        case 'merani':
          this.rolActual = 'DashboardMerani'
          break
        case 'inspirador':
          this.rolActual = 'DashboardInspirador'
          break
        case 'admin':
          this.rolActual = 'DashboardAdmin'
          break
        default:
          this.rolActual = 'DashboardInspirado'
          break
      }
    }
  }
}
</script>
